// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddProviderController from "./add_provider_controller.js"
application.register("add-provider", AddProviderController)

import AdminController from "./admin_controller.js"
application.register("admin", AdminController)

import AutoautosubmitController from "./autosubmit.js"
application.register("autosubmit", AutoautosubmitController)

import DragController from "./drag_controller.js"
application.register("drag", DragController)

import DropzoneController from "./dropzone_controller.js"
application.register("dropzone", DropzoneController)

import FilterTasksController from "./filter_tasks_controller.js"
application.register("filter-tasks", FilterTasksController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import ProcessFlowsController from "./process_flows_controller.js"
application.register("process-flows", ProcessFlowsController)

import ProvidersController from "./providers_controller.js"
application.register("providers", ProvidersController)

import PushToToolsController from "./push_to_tools_controller.js"
application.register("push-to-tools", PushToToolsController)

import RemovalsController from "./removals_controller.js"
application.register("removals", RemovalsController)

import RemoveProviderController from "./remove_provider_controller.js"
application.register("remove-provider", RemoveProviderController)

import SnQueryFormController from "./sn_query_form_controller.js"
application.register("sn-query-form", SnQueryFormController)

import TasksController from "./tasks_controller.js"
application.register("tasks", TasksController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import InsightsController from "./insights_controller.js"
application.register("insights", InsightsController)

import UserIntegrationHubspotController from "./user_integration_hubspot_controller.js";
application.register('user-integration-hubspot', UserIntegrationHubspotController)

import HubspotMappingController from "./hubspot_mapping_controller.js";
application.register('hubspot-mapping', HubspotMappingController)

import HubspotConditionController from "./hubspot_condition_controller.js";
application.register('hubspot-condition', HubspotConditionController)

import HubspotTriggerController from "./hubspot_trigger_controller.js";
application.register('hubspot-trigger', HubspotTriggerController)

import HubspotGroupConditionController from "./hubspot_group_condition_controller.js";
application.register('hubspot-condition-group', HubspotGroupConditionController)

import HubspotMappingFieldsController from "./hubspot_mapping_fields_controller.js";
application.register('hubspot-mapping-fields', HubspotMappingFieldsController)

import HubspotRemoveUsedFieldsController from "./hubspot_remove_used_field_controller.js";
application.register('hubspot-remove-used-fields', HubspotRemoveUsedFieldsController)
